export const reviewModalTitle = (isLastVideo?: boolean) => {
  switch (isLastVideo) {
    case true:
      return "How would you rate this class?";
    case false:
      return "How would you rate your experience with the class so far?";
    default:
      return "How would you rate your experience with the class so far?";
  }
};
